export function isLayoutWithIterations(layout) {
    return !!layout.tick && !!layout.stop;
}
//# sourceMappingURL=types.js.map